export default __webpack_public_path__ + "static/media/india2015B.bd28be28.jpg";